<template>
  <v-hover v-model="buttonHovering">
    <v-list-item class="mt-n0" :class="{ 'ml-n3': $vuetify.breakpoint.xs }">
      <v-list-item-content
        class="ml-n3"
        :class="{ 'ml-n7': $vuetify.breakpoint.xs }"
      >
        <v-row>
          <v-col cols="10">
            <v-list-item-title
              class="subtitle-2"
              :class="{ caption: $vuetify.breakpoint.xs }"
            >
              {{ value }}
            </v-list-item-title>
          </v-col>

          <v-col cols="1" class="ml-n3">
            <v-lazy
              :options="{ threshold: 0.6 }"
              transition="slide-x-reverse-transition"
              class="ma-n1"
            >
              <v-tooltip top max-width="220">
                <template v-slot:activator="{ on }">
                  <v-btn
                    v-on="on"
                    class="ml-3"
                    v-show="showButton"
                    x-small
                    icon
                    color="blue darken-2"
                    @click="action(object)"
                  >
                    <v-icon>{{icon?icon:'mdi-delete'}}</v-icon>
                  </v-btn>
                </template>
                <span>{{ $vuetify.lang.t("$vuetify." + tooltip) }}</span>
              </v-tooltip>
            </v-lazy>
          </v-col>
        </v-row>
      </v-list-item-content>
    </v-list-item>
  </v-hover>
</template>

<script>
export default {
  props: {
    value: String,
    action: Function,
    object: Object,
    tooltip: String,
    icon: String
  },
  data() {
    return {
      showButton: false,
      buttonHovering: false,
    };
  },
  watch: {
    buttonHovering(newVal) {
      this.showButton = newVal;
    },
  },
  methods: {},
};
</script>